module.exports = __webpack_public_path__ + "img/L_321_326.c07e459f.png";